<template>
  <q-input
    outlined
    ref="input"
    v-model="formattedValue"
    :placeholder="placeholder"
    :error="hasError"
    :error-message="errorMessage"
    :disabled="disable"
    :dense="dense"
    :clearable="clearable"
    inputmode="numeric"
    hide-bottom-space
  />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input'
import { watch, onMounted, ref } from 'vue'

export default {
  name: 'QCurrencyInput',
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
    valueRange: {
      type: Object,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const hasError = ref(false)
    const errorMessage = ref('')

    const options = {
      locale: 'en-US',
      currency: 'USD',
      currencyDisplay: 'symbol',
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false,
      precision: 2,
      ...props.options,
    }
    if (props.valueRange) {
      options.valueRange = props.valueRange
    }

    const { inputRef, formattedValue, setValue, numberValue } =
      useCurrencyInput(options)

    const validateValue = (value) => {
      hasError.value = false
      errorMessage.value = ''

      if (value === null || value === '') return

      const numValue = Number(value?.toString().replace(/[$,]/g, ''))

      if (props.valueRange.min !== null && numValue < props.valueRange.min) {
        hasError.value = true
        errorMessage.value = `Value must be at least ${props.valueRange.min}`
      }

      if (props.valueRange.max !== null && numValue > props.valueRange.max) {
        hasError.value = true
        errorMessage.value = `Value cannot exceed ${props.valueRange.max}`
      }
    }

    watch(
      () => numberValue.value,
      (value) => {
        validateValue(value)
      }
    )

    watch(
      () => props.modelValue,
      (value) => {
        setValue(value)
      }
    )

    onMounted(() => {
      setValue(props.modelValue)
    })

    return {
      input: inputRef,
      formattedValue,
      hasError,
      errorMessage,
      numberValue,
    }
  },
}
</script>
